<template lang="html">
  <section class="subview-container column">
		<div class="profile-container">
			<div class="header-part row">
	  		<div class="ctn-profile-light row">
	  			<div class="ctn-profile-picture ctn-profile-pic">
	  				<img id="userPicture" v-img-detect :src="userM.picture" alt="">
	  			</div>
					<div class="ctn-label">
						<div class="ctn-name">
							{{ user.firstname }} {{ user.lastname }}
						</div>
						<div class="link" @click="procNewPicture">
							Éditer la photo
							<input id="newPicture" type="file" v-on:change="uploadNewPicture">
						</div>
						<div class="ctn-ooo" v-if="!userM.isAvailable">
							{{ user.ooo_message }}
						</div>
					</div>
	  		</div>
				<div class="ctn-right column">
					<div class="ctn-available row">
						<div class="label">
							Disponibilité
						</div>
						<toggle-input :value="userM.isAvailable" @change="setAvailable"/>
					</div>
					<div class="btn btn-red small" @click="logout">
						Déconnexion
					</div>
				</div>
	  	</div>
			<div class="body-part row">
				<div class="half edit-profile">
					<form class="default-form-ui" novalidate>
						<div class="title">
							Informations générales
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('email')}">
								<input type="email" v-validate="'required|email'" name="email" v-model="userM.email" placeholder="Email">
							</div>
							<div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('prénom')}">
								<input type="text" v-validate="'required|alpha_spaces'" name="prénom" v-model="userM.firstname" placeholder="Prénom">
							</div>
							<div v-if="errors.has('prénom')" class="error-message">{{ errors.first('prénom') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('nom')}">
								<input type="text" v-validate="'required|alpha_spaces'" name="nom" v-model="userM.lastname" placeholder="Nom">
							</div>
							<div v-if="errors.has('nom')" class="error-message">{{ errors.first('nom') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('adresse')}">
								<input type="text" v-validate="'required'" name="adresse" v-model="userM.address.line" placeholder="Adresse">
							</div>
							<div v-if="errors.has('adresse')" class="error-message">{{ errors.first('adresse') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('code postal')}">
								<input type="text" v-validate="'required|numeric|length:5'" name="code postal" v-model="userM.address.zip" placeholder="Code Postal">
							</div>
							<div v-if="errors.has('code postal')" class="error-message">{{ errors.first('code postal') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('ville')}">
								<input type="text" v-validate="'required|alpha_spaces'" name="ville" v-model="userM.address.city" placeholder="Ville">
							</div>
							<div v-if="errors.has('ville')" class="error-message">{{ errors.first('ville') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('pays')}">
								<input type="text" v-validate="'required|alpha_spaces'" name="pays" v-model="userM.address.country" placeholder="Pays">
							</div>
							<div v-if="errors.has('pays')" class="error-message">{{ errors.first('pays') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('téléphone')}">
								<input type="text" v-validate="'required'" name="téléphone" v-model="userM.phone" placeholder="Téléphone">
							</div>
							<div v-if="errors.has('téléphone')" class="error-message">{{ errors.first('téléphone') }}</div>
						</div>
					</form>
				</div>
				<div class="half edit-password column">
					<form class="form-ui default-form-ui" novalidate>
						<div class="title">
							Mot de passe
						</div>
						<div class="link" @click="displayChangePassword = true">
							Éditer le mot de passe
						</div>
					</form>
					<div class="btn btn-red" @click="saveProfile">
						Sauvegarder
					</div>
				</div>
			</div>
		</div>
		<base-modal :show="showUnavailable" @close="checkUnavailable" :content="contentModal" />
		<base-modal :show="displayChangePassword" @close="displayChangePassword = false" :content="contentModalPassword" />
  </section>
</template>

<script>
import ModalUnavailable from '@/components/Modal/Unavailable'
import ModalChangePassword from '@/components/Modal/ChangePassword'
import { mapGetters } from 'vuex'
export default {
	name: 'Profile',
	data () {
		return {
			userM: {
				email: null,
				firstname: null,
				lastname: null,
				address: {
					line: null,
					zip: null,
					city: null,
					country: null
				},
				phone: null,
				picture: null,
				password: null,
				isAvailable: null
			},
			showUnavailable: false,
			displayChangePassword: false,
			contentModal: ModalUnavailable,
			contentModalPassword: ModalChangePassword
		}
	},
	mounted () {
		this.initUser()
	},
	computed: {
		...mapGetters({
			user: 'user'
		})
	},
	methods: {
		initUser () {
			console.log(this.user)
			this.userM = {
				email: this.user.email,
				firstname: this.user.firstname,
				lastname: this.user.lastname,
				address: {
					line: this.user.address.line,
					zip: this.user.address.zip,
					city: this.user.address.city,
					country: this.user.address.country
				},
				phone: this.user.phone,
				picture: (this.user.picture) ? process.env.ASSETS_ROOT + this.user.picture : process.env.API_ROOT + 'assets/user.png',
				password: null,
				newPassword1: null,
				newPassword2: null,
				isAvailable: this.user.available
			}
		},
		uploadNewPicture (value) {
			const preview = document.getElementById('userPicture')
			const file = value.path[0].files[0]
			const reader = new FileReader()

			reader.addEventListener('load', () => {
				preview.src = reader.result
				this.$store.dispatch('updateProfilePicture', reader.result)
			})

			if (file) {
				reader.readAsDataURL(file)
			}
		},
		procNewPicture () {
			document.getElementById('newPicture').click()
		},
		saveProfile () {
			this.$validator.validate().then((result) => {
				if (result) {
					const shouldLogout = (this.user.email !== this.userM.email)
					this.$store.dispatch('saveProfile', this.userM).then(() => {
						this.$notify({
							type: 'success',
							group: 'default',
							title: 'Félicitations',
							text: (shouldLogout) ? 'Pour valider cette modification vous devrez vous authentifier à nouveau avec votre nouvel email et votre mot de passe actuel' : 'Les modifications ont été apporté à votre profile'
						})
						if (shouldLogout) {
							this.$store.dispatch('allClear')
							this.$router.push({ name: 'Login' })
						}
					}).catch((error) => {
						let message = ''
						if (Object.keys(error.response.data.errors).indexOf('email') !== -1) message = 'Cette adresse email est déjà utilisé'
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: message
						})
					})
				}
			})
		},
		setAvailable (val) {
			this.userM.isAvailable = val
			this.showUnavailable = !val
			if (val) {
				this.$store.dispatch(('setAvailable'), {
					user_id: this.user.id,
					available: 1,
					ooo_message: ''
				}).then(() => {
					this.$notify({
						type: 'success',
						group: 'default',
						title: 'Votre disponibilité a été mise à jour',
						text: ''
					})
				}).catch(() => {
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Votre disponibilité n\'a pas pu être mise à jour',
						text: ''
					})
				})
			}
		},
		checkUnavailable () {
			this.showUnavailable = false
			if (this.user.available) {
				this.userM.isAvailable = this.user.available
			}
		},
		logout () {
			this.$store.dispatch('logout').finally(() => {
				this.$router.push({ name: 'Login' })
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.btn.btn-red.small {
		margin-top: 1rem;
		font-size: 0.8rem;
	}
</style>



// WEBPACK FOOTER //
// Profile.vue?5d147f28